import {useState} from "react";
import {
  CalcHandCandidateParam,
  CalcHandCandidatePoolResult,
  HAND_CANDIDATE_STATUS,
  HandCandidateStatusType
} from "../../../types/pj1dbApiHandling";
import {caclHandCandidate, caclHandCandidatePoll} from "../../../utils/awsAmplifyUtil";
import useMutation from "../../../hooks/useMutation";
import useNotification from "../../../utils/notificationUtil";

export interface UseCalcHandCandidateResult {
  enableConfirm?: boolean;
  validate?: () => boolean | string;
  conditions: CalcHandCandidateParam["conditions"];
  onSuccess?: (data: CalcHandCandidatePoolResult) => void;
}

export function useCalcHandCandidate(params: UseCalcHandCandidateResult) {
  const [status, setStatus] = useState<HandCandidateStatusType>(HAND_CANDIDATE_STATUS.SUBMITTED);
  const {errorMsg} = useNotification();
  const mutation = useMutation({
    enableConfirm: params.enableConfirm,
    validate: params.validate,
    onError: (e) => {
      console.error(e);
      setStatus(HAND_CANDIDATE_STATUS.FAILED);
      errorMsg("計算ジョブの実行に失敗しました。");
    },
    onCompleted: () => {
      setStatus(HAND_CANDIDATE_STATUS.SUCCEEDED);
    },
    mutationFn: async () => {
      setStatus(HAND_CANDIDATE_STATUS.SUBMITTED);
      let newStatus: HandCandidateStatusType = HAND_CANDIDATE_STATUS.SUBMITTED;
      const {isSuccess, data} = await caclHandCandidate({
        conditions: params.conditions,
      });
      if (!isSuccess || data === undefined) {
        return false;
      }

      const timer = setInterval(() => {
        caclHandCandidatePoll(data)
          .then((poolRes) => {
            const poolResData = poolRes.data;
            if (!poolRes.isSuccess || !poolResData) {
              throw new Error("Polling failed");
            }

            newStatus = poolResData.status;
            setStatus(newStatus);
            if (poolResData.status === HAND_CANDIDATE_STATUS.SUCCEEDED || poolResData.status === HAND_CANDIDATE_STATUS.FAILED) {
              clearInterval(timer);
            }
            if (poolResData.status === HAND_CANDIDATE_STATUS.SUCCEEDED) {
              params.onSuccess?.(poolResData);
            }
          })
          .catch((e) => {
            clearInterval(timer);
            newStatus = HAND_CANDIDATE_STATUS.FAILED;
            console.error(e);
          });
      }, 1000 * 5);

      while (!([HAND_CANDIDATE_STATUS.SUCCEEDED, HAND_CANDIDATE_STATUS.FAILED] as string[]).includes(newStatus)) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => {
          setTimeout(resolve, 1000)
        });
      }

      // newStatus の変更を検知できていないため
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return newStatus === HAND_CANDIDATE_STATUS.SUCCEEDED;
    }
  });

  return {
    ...mutation,
    status,
  };
}
